// Send Unmasking Invitation
export const SEND_UNMASKING_INVITATION_REQUEST = 'SEND_UNMASKING_INVITATION_REQUEST';
export const SEND_UNMASKING_INVITATION_DONE = 'SEND_UNMASKING_INVITATION_DONE';
export const SEND_UNMASKING_INVITATION_FAILED = 'SEND_UNMASKING_INVITATION_FAILED';
export const SEND_UNMASKING_INVITATION_RESET = 'SEND_UNMASKING_INVITATION_RESET';